/* Parts enquiry helpers only. Native Shopify contact forms own submission and success. */
(() => {
 'use strict';
 if (window.ZiloxCommerce) { window.ZiloxCommerce.refresh(); return; }
 const mounted = new WeakSet();
 function refresh(root=document) {
  root.querySelectorAll('[data-zx-parts]').forEach(section => {
   if (mounted.has(section)) return; mounted.add(section);
   const select = section.querySelector('[data-zx-category]');
   if (!select) return;
   const selectCategory = category => {
    if (![...select.options].some(option => option.value === category)) return false;
    select.value = category; select.dispatchEvent(new Event('change', {bubbles:true})); return true;
   };
   const requested = new URLSearchParams(location.search).get('category');
   if (requested) selectCategory(requested);
   section.querySelectorAll('[data-zx-part]').forEach(link => link.addEventListener('click', () => {
    selectCategory(link.dataset.zxPart);
    // Retain name/email/message already entered. Only the category changes.
    requestAnimationFrame(() => {
     const target = document.getElementById('zx-enquiry-heading');
     if (target) { target.tabIndex=-1; target.focus({preventScroll:true}); }
    });
   }));
  });
 }
 document.addEventListener('shopify:section:load', event => refresh(event.target));
 window.ZiloxCommerce={refresh};
 if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>refresh(),{once:true}); else refresh();
})();
